export default {
  id: 237,
  title: 'Target #237 - Round castle',
  url: 'https://cssbattle.dev/play/237',
  colors: ['#3F4869', '#F4DA64', '#E25C57'],
  solution:
    '<p><style>body{background:#3f4869}p{position:fixed;margin:0;top:43;left:90;width:220;height:214;background:conic-gradient(from 270deg at 55px 110px ,transparent 270deg,#f4da64 270deg),conic-gradient(from 180deg at 165px 110px ,transparent 270deg,#e25c57 270deg),linear-gradient(90deg ,#e25c57 90px,transparent 90px 130px,#f4da64 130px),linear-gradient(transparent 174px,#3f4869 174px),linear-gradient(90deg ,#e25c57 110px,#f4da64 110px);border-radius:9in 9in 0 0',
}
